import Event from "common/event";
import { ActionWithDispatch } from "common/actionWithDispatch";
import { DeliveryMethodDetails } from "domain/deliveryMethod";
import deliveryMethodsService from "./deliveryMethods.service";

export class DeliveryMethodsLoaded extends Event {
    constructor(public deliveryMethods: DeliveryMethodDetails[]) {
        super(DeliveryMethodsLoaded.EventName);
    }

    public static EventName: string = "deliveryMethods/loaded";
}

export function loadDeliveryMethods(): ActionWithDispatch<DeliveryMethodsLoaded> {
    return function (dispatch) {
        return deliveryMethodsService
            .listDeliveryMethods()
            .then(m => dispatch(new DeliveryMethodsLoaded(m).toObject()));
    };
}